import { PendingShipmentChangeRequests } from "@/features/shipments/pending-shipment-change-requests";
import { useCenterScopeNotApplicable } from "@/contexts/carrier-scope-context";

export function ShipmentChangeRequestsScreen() {
  // Change requests are shipment-level — carrier-scoped, not center-scoped.
  useCenterScopeNotApplicable();

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-2xl font-bold">Shipment Change Requests</h1>
      <PendingShipmentChangeRequests />
    </div>
  );
}
